module.exports = __webpack_public_path__ + "static/media/48377052_2308757185866126_3204192847179808768_o-thumb.e32500b9.jpg";